import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type {
  ShippingZoneCreateInput,
  ShippingZoneUpdateInput,
} from "@/modules/shipping/domain/contracts";
import { isDevMode } from "@/shared/lib/config";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircleIcon } from "lucide-react";
import { useCreateZone } from "../api/queries";
import { ZoneFormTour, useZoneFormTour } from "../tour";
import { ZoneForm } from "../ui/ZoneForm";

export function ZoneCreatePage() {
  const nav = useNavigate({ from: "/app/shipping/zones/new" });
  const createZone = useCreateZone();
  const { run, handleJoyrideCallback, startTour } = useZoneFormTour();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ໂຊນ", to: "/app/shipping/zones" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງໂຊນ{" "}
              <Button
                variant="ghost"
                size="icon"
                onClick={startTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            </h2>
            <p className="text-muted-foreground">
              ເພີ່ມໂຊນຄ່າສົ່ງ — ລະຫັດ, ຊື່ 3 ພາສາ, ລຳດັບ.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/shipping/zones" } as any)}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <div className="mt-6 rounded-xl border bg-card p-6">
          <ZoneForm
            onSubmit={async (
              values: ShippingZoneCreateInput | ShippingZoneUpdateInput,
            ) => {
              await createZone.mutateAsync(values as ShippingZoneCreateInput);
              nav({ to: "/app/shipping/zones" } as any);
            }}
            onCancel={() => nav({ to: "/app/shipping/zones" } as any)}
            submitting={createZone.isPending}
            onDevFill={isDevMode ? () => {} : undefined}
          />
        </div>
        <ZoneFormTour run={run} onCallback={handleJoyrideCallback} />
      </Main>
    </>
  );
}
